import { WidgetConfig } from '@wix/da-gruser-shared/pkg/types/widget';
import defaultRemoveConfirmation from '@wix/da-shared-react/pkg/widgets/defaultRemoveConfirmation';
import GroupAboutBoxWide from './GroupAboutBoxWide';
import EditPopup from './EditPopup';

export const getGroupAboutWidgetWideConfig = ({ t, dispatch }): WidgetConfig => ({
  viewComponent: GroupAboutBoxWide,
  configPopoverComponent: EditPopup,
  confirmRemove: () => defaultRemoveConfirmation({ t, dispatch }),
  widgetCard: {
    minuatureImageSrc:
      'https://st.deviantart.net/eclipse/widgets/miniatures/2022/il8-22-about-me.svg',
    title: t('widgets.group_about.addButtonHeader'),
    description: t('widgets.group_about.description'),
  },
});
export default getGroupAboutWidgetWideConfig;
